var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 4.4C1.25 2.6603 2.6603 1.25 4.4 1.25H13.6C15.3397 1.25 16.75 2.6603 16.75 4.4V6.25H19.6C21.3397 6.25 22.75 7.6603 22.75 9.4V18.6C22.75 20.3397 21.3397 21.75 19.6 21.75H10.4C8.6603 21.75 7.25 20.3397 7.25 18.6V16.75H4.4C2.6603 16.75 1.25 15.3397 1.25 13.6V4.4ZM8.75 18.6C8.75 19.5113 9.48873 20.25 10.4 20.25H19.6C20.5113 20.25 21.25 19.5113 21.25 18.6V9.4C21.25 8.48873 20.5113 7.75 19.6 7.75H10.4C9.48873 7.75 8.75 8.48873 8.75 9.4V18.6ZM15.25 6.25H10.4C8.6603 6.25 7.25 7.6603 7.25 9.4V15.25H4.4C3.48873 15.25 2.75 14.5113 2.75 13.6V4.4C2.75 3.48873 3.48873 2.75 4.4 2.75H13.6C14.5113 2.75 15.25 3.48873 15.25 4.4V6.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.784bd36b5b6d32cbf15195c200ca0e5b.svg";
export { ForwardRef as ReactComponent };